module.exports = __webpack_public_path__ + "static/media/icon-missing-asset-red.d4e78428.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/icon-missing-asset-red.svg
// module id = 739
// module chunks = 57